export const inspectTable = [
  {
    id: 1,
    content:
      "예초기 작업 중 예초기 날이 돌 또는 굵은 나무 등에 부딪치지 않도록 주의하는가?",
    is_checked: "",
  },
  {
    id: 2,
    content:
      "돌 등에 부딪힌 경우에는 엔진을 정지시키고 톱날의 이상 유무를 확인하는가?",
    is_checked: "",
  },
  {
    id: 3,
    content:
      "예초기를 들고 작업장 이동 시 안전거리(10㎝ 이상) 내에는 다른 작업자의 접근을 금지하는가?",
    is_checked: "",
  },
  {
    id: 4,
    content: "작업 반경(10m 이상) 내에서 다른 작업자의 접근을 금지하는가?",
    is_checked: "",
  },
  {
    id: 5,
    content: "톱날이 넝쿨에 휘감기지 않도록 주의하는가?",
    is_checked: "",
  },
  {
    id: 6,
    content: "넝쿨 위 부분을 1차로 작업한 후 아래 부분을 작업하는가?",
    is_checked: "",
  },
  {
    id: 7,
    content: "작업 방향은 우측에서 좌측으로 실시하는가?",
    is_checked: "",
  },
  {
    id: 8,
    content:
      "경사 방향으로 작업을 진행하고 급경사지에서는 작업을 금지하고 있는가?",
    is_checked: "",
  },
]
